module.exports = __webpack_public_path__ + "img/lt.48f51d55.png";